
import { kebabCase } from 'lodash'
import { NavbarItemData } from './navbar'
import { computed, defineComponent, PropType } from 'vue'
export default defineComponent({
  name: 'NavbarItem',
  props: {
    navbarItemData: {
      type: Object as PropType<NavbarItemData>,
      required: true
    }
  },
  setup (props) {
    const className = computed(() => kebabCase(props.navbarItemData.options.name))

    return {
      className
    }
  }
})
